"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InventoryWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _InventoryWindowModule = _interopRequireDefault(require("./InventoryWindow.module.scss"));

var _ItemPool = _interopRequireDefault(require("../../../entities/ItemPool/ItemPool"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _InventoryWindow = _interopRequireDefault(require("./InventoryWindow.i18n"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function InventoryWindow(_ref) {
  var equipment = _ref.equipment,
      itemPool = _ref.itemPool,
      _ref$pp = _ref.pp,
      pp = _ref$pp === void 0 ? 0 : _ref$pp,
      _ref$gp = _ref.gp,
      gp = _ref$gp === void 0 ? 0 : _ref$gp,
      _ref$cp = _ref.cp,
      cp = _ref$cp === void 0 ? 0 : _ref$cp,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  if (itemPool && (itemPool.sizeX !== 7 || itemPool.sizeY !== 6)) {
    throw new Error("itemPool with invalid size '".concat(itemPool.sizeX, "x").concat(itemPool.sizeY, "' was passed to InventoryWindow."));
  }

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSecondaryHandsVisible = _useState2[0],
      setIsSecondaryHandsVisible = _useState2[1];

  var renderEquipmentSlot = (0, _react.useCallback)(function (slotType, sizeX, sizeY) {
    /*
        TODO
        const equipmentSlot = equipmentSlots.find((slot: IEquipmentSlot) => {
            return slot.type.id === slotType;
        });
        if (!equipmentSlot) {
            throw new Error(`Unable to render equipment slot '${slotType}' on equipment ${equipment.id}.`);
        }
        const equipmentSlot = undefined;
        const item = equipmentSlot ? equipmentSlot.item : undefined;
        */
    var item = undefined;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _InventoryWindowModule.default[slotType]
    }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
      sizeX: sizeX,
      sizeY: sizeY,
      singleItem: item
    }));
  }, []);
  var renderEquipment = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderEquipmentSlot("neck", 1, 1), renderEquipmentSlot("finger1", 1, 1), renderEquipmentSlot("finger2", 1, 1), renderEquipmentSlot("head", 2, 2), renderEquipmentSlot("back", 2, 2), !isSecondaryHandsVisible && renderEquipmentSlot("handLeft", 2, 4), !isSecondaryHandsVisible && renderEquipmentSlot("handRight", 2, 4), isSecondaryHandsVisible && renderEquipmentSlot("hand2Left", 2, 4), isSecondaryHandsVisible && renderEquipmentSlot("hand2Right", 2, 4), renderEquipmentSlot("chest", 2, 3), renderEquipmentSlot("arms", 2, 2), renderEquipmentSlot("legs", 2, 3), renderEquipmentSlot("feet", 2, 2), renderEquipmentSlot("bag1", 1, 1), renderEquipmentSlot("bag2", 1, 1));
  }, [renderEquipmentSlot, isSecondaryHandsVisible]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_InventoryWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _InventoryWindowModule.default.dragHandler,
    classNameCloseBtn: _InventoryWindowModule.default.closeBtn
  }), renderEquipment(), /*#__PURE__*/_react.default.createElement("div", {
    className: _InventoryWindowModule.default.btnChange1
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.INVENT_L_CHANGE,
    onClick: function onClick() {
      return setIsSecondaryHandsVisible(!isSecondaryHandsVisible);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _InventoryWindowModule.default.btnChange2
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.INVENT_R_CHANGE,
    onClick: function onClick() {
      return setIsSecondaryHandsVisible(!isSecondaryHandsVisible);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _InventoryWindowModule.default.itemPool
  }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
    sizeX: 7,
    sizeY: 6,
    itemPool: itemPool
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _InventoryWindowModule.default.bagQuest
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _InventoryWindowModule.default.treasure
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _InventoryWindowModule.default.trash
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_InventoryWindowModule.default.money, " ").concat(_InventoryWindowModule.default.PP)
  }, pp), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_InventoryWindowModule.default.money, " ").concat(_InventoryWindowModule.default.GP)
  }, gp), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_InventoryWindowModule.default.money, " ").concat(_InventoryWindowModule.default.CP)
  }, cp), /*#__PURE__*/_react.default.createElement("div", {
    className: _InventoryWindowModule.default.btnShop
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PRIVATE_SHOP
  }, formatMessage(_InventoryWindow.default.shopBtn))));
}